import { DialogContent, DialogTitle, Stack } from "@mui/material";
import { productImportWarehouseBusiness } from "api/bussiness/product/product-import-warehouse-bussiness";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { DynamicFormArray } from "commons/ultilities/dynamic-form/components/dynamic-form-array";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import { IControl } from "commons/ultilities/dynamic-form/models/control";
import { createProductOptionLabel } from "commons/ultilities/option-item/label-ultil";
import { observer } from "mobx-react-lite";
import { IUpdateProductGoodsReceipt } from "mobx-stores/_models/product-inventory/product-goods-receipt/product-goods-receipt";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useEffect, useMemo } from "react";
import { DialogForm } from "share-components/templates/form/dialog-form";
import { getUpdateProductGoodsReceiptSchema } from "./schema";

export const UpdateProductGoodsReceipt = observer(() => {
  const {
    productInventoryManagement: {
      productGoodsReceiptStore: {
        openEdit,
        getProductGoodsReceipt,
        productGoodsReceiptDetail,
        setProp,
      },
    },
  } = useStores();
  const {
    form: { controls, isValid },
    getControl,
    submitHandler,
    setDefaults,
  } = useForm<IUpdateProductGoodsReceipt>(
    getUpdateProductGoodsReceiptSchema(),
    {
      id: productGoodsReceiptDetail?.id,
      importDate: productGoodsReceiptDetail?.importDate,
      items: [],
    }
  );

  useEffect(() => {
    if (productGoodsReceiptDetail) {
      setDefaults({
        id: productGoodsReceiptDetail?.id,
        importDate: productGoodsReceiptDetail?.importDate,
        items: productGoodsReceiptDetail.items.map((x) => ({
          id: x.id,
          productId: x.productId,
          location: x.location,
          note: x.note,
          quantity: x.quantity,
        })),
      });

      if (
        productGoodsReceiptDetail.items &&
        productGoodsReceiptDetail.items.length > 0
      ) {
        getControl("items").children.forEach((row: IControl[]) => {
          const idCtr = row.filter((x) => x.name === "id")?.[0];
          const data = productGoodsReceiptDetail.items.filter(
            (x) => idCtr && x.id === idCtr.value
          )?.[0];

          const productIdCtr = row.filter((x) => x.name === "productId")?.[0];
          if (productIdCtr && data?.product) {
            productIdCtr.setProp("optionItems", [
              {
                label: createProductOptionLabel(data.product),
                value: data.product?.id,
              },
            ]);
          }
        });
      }
    }
  }, [
    controls,
    getControl,
    productGoodsReceiptDetail,
    productGoodsReceiptDetail?.id,
    productGoodsReceiptDetail?.importDate,
    productGoodsReceiptDetail?.items,
    setDefaults,
  ]);

  const saveHandler = useCallback(
    async (data: IUpdateProductGoodsReceipt) => {
      try {
        if (!productGoodsReceiptDetail?.id) return;
        await productImportWarehouseBusiness.update(
          productGoodsReceiptDetail?.id,
          data
        );
        await getProductGoodsReceipt();
        setProp("openEdit", false);
      } catch (ex) {
        console.error(ex);
      }
    },
    [getProductGoodsReceipt, productGoodsReceiptDetail?.id, setProp]
  );

  const itemsControl = useMemo(() => {
    return getControl("items").children;
  }, [getControl]);

  return (
    <DialogForm
      open={openEdit}
      fullWidth
      maxWidth={"sm"}
      onClose={() => setProp("openEdit", false)}
      onCancelBtnClicked={() => setProp("openEdit", false)}
      onSaveBtnClick={async () => await submitHandler(saveHandler)}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>Sửa nhập kho</DialogTitle>
      <DialogContent>
        <Stack sx={{ marginTop: "10px" }}>
          <DynamicForm controls={controls}></DynamicForm>
          {itemsControl && itemsControl.length > 0 && (
            <DynamicFormArray
              children={itemsControl}
              controlSpacing={2}
            ></DynamicFormArray>
          )}
        </Stack>
      </DialogContent>
    </DialogForm>
  );
});
